import { JsonObject } from '../../../Assembler/dist/app/json/jsonValue.js';

/**
 * Per-merge mutable state for dynamic handler results (AssemblerJson variant).
 * Fresh instance created per MergeTemplates call -- no clearDynamicResults needed.
 * Engine creates and owns the DynamicResultsJson; loader writes to it via setDynamicResults.
 */
export class DynamicResultsJson {
    /** DynamicData handler outputs: Key = "ComponentName_HandlerType" */
    dynamicDataResults: JsonObject = new JsonObject();

    /** DynamicView handler outputs: Key = "ComponentName_HandlerType" */
    dynamicViewResults: JsonObject = new JsonObject();

    /** DynamicAction handler outputs: Key = "ComponentName_HandlerType" */
    dynamicActionResults: JsonObject = new JsonObject();

    /**
     * DynamicClientData RAW island set: Key = "ComponentName_<IClientDataType>". Separate from
     * dynamicDataResults so the raw client set never mixes into the server-baked DataJson; the same value later
     * feeds the Embedded island and the on-demand slice. INTENTIONALLY double-purposed (server produce vs
     * client re-emit share this one map so the client re-emit reproduces the server page-tail island
     * byte-for-byte). Holds only the RAW island; the consumer's FILTERED output is tracked in
     * dynamicClientResults.
     */
    dynamicClientDataResults: JsonObject = new JsonObject();

    /**
     * DynamicClient CONSUMER outputs (FILTERED set the browser-side IClient produced from the raw island):
     * Key = "ComponentName_ClientDataKey". The client-tier counterpart to dynamicClientDataResults (the raw
     * preparer set) — populated by applyClientHandlers on the clientMode re-merge so the round-trip can
     * cross-check every engine's consumer output.
     */
    dynamicClientResults: JsonObject = new JsonObject();

    /** Resolved JSON per template after DynamicData handlers: Key = templateName */
    resolvedTemplateJson: JsonObject = new JsonObject();
}
